export default {
    LOGIN: "SUPPLIER_LOGIN:USERMODEL",
    ACCOUNT_CHECK_STATUS: "ACCOUNT_CHECK_STATUS",
    MSG_TYPE_LIST: "MSG_TYPE_LIST",
    APP_VERSION: "APP_VERSION",
    IS_BIND_OFFICIAL_ACCOUNT: "IS_BIND_OFFICIAL_ACCOUNT",
};
